function isHttpSuccess(r) {
    return r.status >= 200 && r.status <= 299;
}

export function getResourceId(d) {
    return !d ? undefined : d.id || d["@id"];
}

export function sort(items, propName = 'title', direction = 'asc') {
    items.sort((aItem, bItem) => {
        let a = direction === 'asc' ? aItem : bItem
        let b = direction === 'asc' ? bItem : aItem
        if(a[propName] === undefined ) {
            return 1;
        }
        if( b[propName] === undefined) {
            return -1;
        }

        if (b[propName] > a[propName]) {
            return -1;
        }
        if (b[propName] < a[propName]) {
            return 1;
        }
        return 0;
    });
    return items;
}

export function sortByFunction(items, valueProvider , direction = 'asc') {
    items.sort((aItem, bItem) => {
        let a = direction === 'asc' ? aItem : bItem
        let b = direction === 'asc' ? bItem : aItem
        let valueB = valueProvider(b);
        let valueA = valueProvider(a);
        if(valueA === undefined ) {
            return 1;
        }
        if( valueB === undefined) {
            return -1;
        }

        if (valueB > valueA) {
            return -1;
        }
        if (valueB < valueA) {
            return 1;
        }
        return 0;
    });
    return items;
}

export function toArray(value) {
    if(value !== undefined && value !== null) {
        if (value?.constructor === Array) {
            return value;
        } else {
            return [value]
        }
    } else {
        return []
    }
}

export async function getAuthorizationToken(configuration, username, password) {
    const formData = new FormData();
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify({username, password}));
    formData.append('headers', JSON.stringify({'Content-Type' : 'application/json'}));

    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch(requestOptions, `/graphologi/authenticate`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}

export async function getSubscriptions(configuration, user) {
    const formData = new FormData();
    formData.append('verb', 'GET');
    formData.append('body', JSON.stringify(''));
    formData.append('headers', JSON.stringify({
        "Accept": "application/json",
        "Authorization": `Bearer ${user.token}`
    }));

    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch(requestOptions, `/graphologi/subscription`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }

}

export async function getProjects(configuration, user, subscription, type = "https://grafsync.graphifi.com/schema/gs/TaxonomyProject", pageSize=100) {
    const body = {
        "search": [{
            "predicate": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
            "value": type
        }, {
            "predicate": "https://grafsync.graphifi.com/schema/gs/isVersionOfProject",
            "invert": true
        }],
        "searchMode": "Compliant",
        "exclude": [],
        "sort": ["http://purl.org/dc/terms/title"],
        "page": 1,
        "pageSize": pageSize,
        "subscription": getResourceId(subscription),
        "outputUnd": true
    }
    const formData = new FormData();
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify(body));
    formData.append('headers', JSON.stringify({
        "Accept": "application/ld+json",
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.token}`,
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch( requestOptions, `/graphologi/search`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}

export async function loadResources(configuration, project, subscription, user, iris) {
    const body = {
        "resources": [
            {
                "graph": `${project.inNamedGraph}`,
                "iri": iris
            }
        ],
        "subscription": getResourceId(subscription)
    }
    const formData = new FormData();
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify(body));
    formData.append('headers', JSON.stringify({
        "Accept": "application/ld+json",
        "Authorization": `Bearer ${user.token}`,
        "Content-Type": "application/json",
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch(requestOptions, `/graphologi/resource`);
    if (isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status: r.status, error: await r.text()}
    }
}

export async function getProjectResources(configuration, user, subscription, project, pageSize=100) {
    return await loadResources(configuration, project, subscription, user, project.hasComponent);
}

export async function exportConceptScheme(configuration, user, subscription, project, iri, pageSize=100) {
    const body = {
        "iri": iri,
        "graph": `${project.inNamedGraph}`,
        "subscription": getResourceId(subscription),
        "embed": true,
        "options": ["includeXL"]
    }
    const formData = new FormData();
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify(body));
    formData.append('headers', JSON.stringify({
        "Accept": "application/ld+json",
        "Authorization": `Bearer ${user.token}`,
        "Content-Type": "application/json",
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch( requestOptions, `/graphologi/view/export`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}

export async function exportOntology(configuration, user, subscription, project, iri, pageSize=100) {
    const body = {
        "iri": iri,
        "graph": `${project.inNamedGraph}`,
        "subscription": getResourceId(subscription),
        "embed": true,
        "options": ["includeXL"]
    }
    const formData = new FormData();
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify(body));
    formData.append('headers', JSON.stringify({
        "Accept": "application/ld+json",
        "Authorization": `Bearer ${user.token}`,
        "Content-Type": "application/json",
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch(requestOptions, `/graphologi/view/ontologyexport`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}

export async function createInstance(configuration, user, subscription, resource) {
    const body = resource
    const formData = new FormData();
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify(body));
    formData.append('headers', JSON.stringify({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.token}`,
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch( requestOptions, `/graphologi/instance`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        const status = await waitForInstanceStatus(user, subscription, j.id);
        if(status === 'Slow') {
            return {status : r.status, error : status}
        }
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}

export async function patchInstance(configuration, user, subscription, body) {
    const formData = new FormData();
    formData.append('verb', 'PATCH');
    formData.append('body', JSON.stringify(body));
    formData.append('headers', JSON.stringify({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.token}`,
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch(requestOptions, `/graphologi/instance`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        const status = await waitForInstanceStatus(user, subscription, j.id);
        if(status === 'Slow') {
            return {status : r.status, error : status}
        }

        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}

async function waitForInstanceStatus(configuration, user, subscription, id) {
    let inProgress = true;
    let counter = 0;
    while (inProgress && counter < 4) {
        const status = await checkStatus(configuration, user, subscription, id);
        if(status.status === 'Processed') {
            return status.status;
        } else {
            await new Promise(r => setTimeout(r, 500));
        }
    }
    return 'Slow';
}

async function checkStatus(configuration, user, subscription, id) {
    const body = {
        "subscription": `${getResourceId(subscription)}`,
        "id": id
    }
    const formData = new FormData();
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify(body));
    formData.append('headers', JSON.stringify({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.token}`,
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch( requestOptions, `/graphologi/instance/status`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }

}

export async function postData(configuration, user, projectId, subscription, data, filename, options) {
    const formData = new FormData();
    formData.append('file', new File([new Blob([JSON.stringify(data)])], filename));
    formData.append('verb', 'POST');
    formData.append('body', JSON.stringify({"options" : JSON.stringify(options)}));
    formData.append('headers', JSON.stringify({
        "Authorization": `Bearer ${user.token}`,
        "Graphologi-Target": `${subscription.subscriptionBucket}`,
        "Accept" : "application/ld+json"
    }));
    const requestOptions = {
        method: "POST",
        body: formData,

    }
    const r = await configuration.executeFetch( requestOptions, `/graphologi/data?project=${projectId}&subscription=${subscription.id}`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}

export async function dataStatus(configuration, user, subscription, postDataResponse){
    const formData = new FormData();

    formData.append('verb', 'GET');
    formData.append('headers', JSON.stringify({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.token}`,
        "Graphologi-Target": `${subscription.subscriptionBucket}`
    }));
    const requestOptions = {
        method: "POST",
        body: formData
    }
    const r = await configuration.executeFetch( requestOptions, `/graphologi${postDataResponse.path}?subscription=${subscription.id}`);
    if(isHttpSuccess(r)) {
        const j = await r.json();
        return j;
    } else {
        return {status : r.status, error : await r.text()}
    }
}